import 'preact/debug';
import './main.css';
import 'utils/icon-sprite.js';
import Layout from 'utils/layout';
import Video from 'utils/video';
import EventListeners from 'utils/event-listeners';

(() => {
  const eventListeners = new EventListeners();
  eventListeners.init();

  const EAGER_SECTIONS = new Set(['header', 'cart', 'product', 'search', 'quick-add', 'stylitics-ui', 'shop-the-look-modal', 'country-localization', 'plp-content-injection', 'plp-product-grid']);
  const loadingSections = new Map();
  const loadedSections = new Set();

  const uniq = (value, index, self) => self.indexOf(value) === index;
  const sections = document.querySelectorAll('[data-section]');
  const sectionNames = [...sections]
    .map((section) => section.dataset.section)
    .filter(uniq);
  const eagerSectionsName = sectionNames
    .filter((name) => EAGER_SECTIONS.has(name)); 

  const seenSectionNames = new Set();
  const lazySectionsArray = [...sections]
    .filter((section) => !EAGER_SECTIONS.has(section.dataset.section))
    .filter((section) => {
      const name = section.dataset.section;
      if (seenSectionNames.has(name)) return false;
      seenSectionNames.add(name);
      return true;
    });
  const layout = Layout.getInstance();

  const initSection = (name, m) => {
    const module = m.default;
    if (!module) return;
    const modules = [...sections].filter(
      (section) => section.dataset.section === name,
    );
    modules.forEach((element) => {
      const dataEl = element.querySelector('[data-section-data]');
      const data = dataEl ? JSON.parse(dataEl.textContent) : {};

      const videoEls = element.querySelectorAll('[data-component="video"]');
      const videos =
        videoEls &&
        [...videoEls].map(
          (videoEl) => new Video({ element, video: videoEl, layout }),
        );
      module(element, { ...data, layout, videos });
    });
  };

  const loadSection = (name) => {
    if (loadedSections.has(name)) return Promise.resolve();
    if (loadingSections.has(name)) return loadingSections.get(name);
    const p = import(`./${name}/index.js`).then((m) => {
      initSection(name, m);
      loadedSections.add(name);
      // eslint-disable-next-line no-console
    }).catch(console.error).finally(() => loadingSections.delete(name));
    loadingSections.set(name, p);
    return p;
  };

  eagerSectionsName.forEach((name) => {
    loadSection(name);
  });

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      loadSection(entry.target.dataset.section);
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '350px 0px' });

  lazySectionsArray.forEach((section) => {
    observer.observe(section);
  });

  if (window.Shopify.country !== 'US') {
    const hiddenElements = document.querySelectorAll('[data-ge-hidden]');
    hiddenElements.forEach((element) => {
      element.remove();
    });
    const path = window.location.pathname;
    const redirectPaths = [
      '/pages/vip-rewards',
      '/pages/rewards',
      '/vip-rewards',
      '/rewards',
    ];

    if (redirectPaths.includes(path)) {
      window.location.href = '/pages/404';
    }
  }
})();
